import { useState } from "react";

const ASSET_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1/assets/protocol`;

export const protocolLogoUrl = (slug: string) => `${ASSET_BASE}/${encodeURIComponent(slug)}`;

/* Shared protocol identity medallion. Official logo (backend-resolved & cached)
   wins; initials are fallback only. Fixed dimensions — zero layout shift. */
export const ProtocolLogo = ({ slug, name, size = 32, ring = true, fill = false, className = "" }: {
  slug: string; name: string; size?: number; ring?: boolean; fill?: boolean; className?: string;
}) => {
  const [err, setErr] = useState(false);
  const inner = fill ? size : Math.round(size - Math.max(6, size * 0.22));
  const initials = (name || slug).split(/\s+/).map((w) => w[0]).join("").slice(0, 2).toUpperCase();
  return (
    <span aria-hidden data-testid={`protocol-logo-${slug}`}
      className={`relative grid place-items-center rounded-full shrink-0 ${ring ? "nl-logo-ring" : ""} ${className}`}
      style={{ width: size, height: size }}>
      {!err ? (
        <img src={protocolLogoUrl(slug)} alt="" width={inner} height={inner}
          loading="lazy" decoding="async" onError={() => setErr(true)}
          className="relative rounded-full" style={{ width: inner, height: inner }} />
      ) : (
        <span className="relative font-mono font-bold text-gray-200"
          style={{ fontSize: Math.max(9, size * 0.3) }}>{initials}</span>
      )}
    </span>
  );
};
